export default __webpack_public_path__ + "static/media/partner-7-sipher.f40abc8e.png";